import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useState } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import labels from "../../constants/Tax";
// Add Tax
function Add({ history }) {
  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];
  const typeOpt = [
    
    { id: 1, title: "Percentage", value: "percentage" },
    { id: 2, title: "Amount", value: "amount" },
  ];
  const fieldArr = [
    { id: 0, title: "Title", name: "name", type: "TextInput" },
    { id: 1, title: "Type", name: "type", type: "Dropdown", options: typeOpt },
    { id: 2, title: "Value", name: "value", type: "TextInput", is_number:true },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ];

  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({
    name: "",
    type: "",
    value: "",
    status: "",
  });


  function handleValidation() {
    let flag = true;
    let error = {}
    if (!fields.name) {
      error['name'] = "Please enter tax name"
      flag = false
    } 
   
    if (!fields.value) {
      error['value'] = "Please enter value "
      flag = false
    }
    if (!fields.type) {
      error['type'] = "Please select type"
      flag = false
    }
    if (!fields.status) {
      error['status'] = "Please select status"
      flag = false
    }
    setErrors({ ...error })
    return flag;
  }

  const handleSubmit = () => {
    if (handleValidation()) {

      configuration
        .postAPI({ url: "tax/create", params: fields })
        .then((data) => {
          if (data.status === 200) {
            history.push("/tax");
            // setData(data.payload)
          } else if (data.error) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          return toast.error(error.message);
        });
    }
  };

  // function handleChange(field, e) {
  //   if (fields === 'value') {
  //     if (e.target.value) {
  //       setFields({ ...fields, [field]: e.target.value });
  //     }
  //   } else {
  //     setFields({ ...fields, [field]: e.target.value });
  //   }
  // }
  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value });
  }
  return (
    <>
      <Breadcrumb module={labels.addTax} />
      <AddEditSection
        title="Add Tax"
        path="/tax"
        fields={fieldArr}
        fieldError={errors}

        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
